import LzMCrud from '@lz-models/crud/Crud';

const config = new LzMCrud({
    ident: 'items',
    baseRoute: '/params/items',
    fields: {
        hs_code: { size: 20, type: 'string', required: true },
        code: { size: 10, type: 'string', required: true },
        type_name: { size: 100, type: 'string', required: true },
        size_name: { size: 100, type: 'string', required: true },
        quality_name: { size: 100, type: 'string', required: true },
        default_price: { type: 'number', required: false },
        is_active: { type: 'boolean', default: true },
    },
    listingColumns: {
        hs_code: { label: 'HS Code', sortable: true, alignment: 'left' },
        code: { label: 'Code', sortable: true, alignment: 'left' },
        type_name: { label: 'Type Name', sortable: true, alignment: 'left' },
        size_name: { label: 'Size Name', sortable: true, alignment: 'left' },
        quality_name: { label: 'Quality Name', sortable: true, alignment: 'left' },
    },
    addFormInputs: {
        hs_code: { label: 'HS Code' },
        code: { label: 'Code' },
        type_name: { label: 'Type Name' },
        size_name: { label: 'Size Name' },
        quality_name: { label: 'Quality Name' },
        default_price: { label: 'Default Price' },
        is_active: { label: 'Active', type: 'switch' },
    },
    viewFormFields: {
        hs_code: { label: 'HS Code' },
        code: { label: 'Code' },
        type_name: { label: 'Type Name' },
        size_name: { label: 'Size Name' },
        quality_name: { label: 'Quality Name' },
        default_price: { label: 'Default Price' },
        is_active: { label: 'Active', displayFunction: (val) => !!val ? 'Active' : 'In-Active' },
    },
    editFormInputs: {
        hs_code: { label: 'HS Code' },
        code: { label: 'Code' },
        type_name: { label: 'Type Name' },
        size_name: { label: 'Size Name' },
        quality_name: { label: 'Quality Name' },
        default_price: { label: 'Default Price' },
        is_active: { label: 'Active', type: 'switch' },
    },
});

export default config;
